var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4634 8.85452C13.4634 7.27849 14.7416 6 16.3183 6H31.6818C33.2585 6 34.5366 7.27849 34.5366 8.85452V12.1463C34.5366 16.0533 32.4099 19.464 29.2509 21.2835C28.2557 21.8567 27.5122 22.8515 27.5122 24C27.5122 25.1485 28.2557 26.1433 29.2509 26.7165C32.4099 28.536 34.5366 31.9467 34.5366 35.8537V39.1455C34.5366 40.7215 33.2584 42 31.6818 42H16.3183C14.7416 42 13.4634 40.7215 13.4634 39.1455V35.8537C13.4634 31.9467 15.5901 28.536 18.7491 26.7165C19.7444 26.1433 20.4878 25.1485 20.4878 24C20.4878 22.8515 19.7444 21.8567 18.7491 21.2835C15.5901 19.464 13.4634 16.0533 13.4634 12.1463V8.85452Z",
    fill: "url(#paint0_linear_3567_2171)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2348 33.0748C22.7136 32.6038 23.3445 32.3418 24 32.3418C24.6554 32.3418 25.2864 32.6038 25.7651 33.0748L30.7877 38.0156C31.2793 38.4992 30.954 39.3662 30.281 39.3662H17.719C17.0459 39.3662 16.7207 38.4992 17.2123 38.0156L22.2348 33.0748Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3567_2171",
    x1: 13.4634,
    y1: 6,
    x2: 44.8185,
    y2: 25.2805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/Hourglass.817ef93efeedb2dc307c0891cc48a34b.svg";
export { ForwardRef as ReactComponent };